// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fcd9e6c7","480":"676699e0","647":"9d2e6a0e","972":"983c3ed4"}[chunkId] + ".chunk.js";
};